<template>
    <main>
        <div class="alert alert-warning mt-2" v-if="!incapacidades.length">
            No existen incapacidades...
        </div>
        <div v-else class="card mt-2 border-gray-500 shadow-none" v-for="item in incapacidades" :key="item.id">
            <div class="card-header bg-light">
                <div class="row">
                    <div class="col-4">
                        <span class="font-weight-bold">Incapacidad No. {{item.id}}</span>
                        <span class="badge badge-danger ml-2" v-if="item.es_retroactiva === 'Si'">RETROACTIVA</span>
                    </div>
                    <div class="col-8 d-flex justify-content-end align-items-center">
                        <span class="text-muted mr-3"><i class="fas fa-user-md mr-1"></i> {{item.user.name}} ({{item.created_at | formatDateTime}})</span>
                        <button v-if="item.id_user === user.id" @click="eliminar(item.id);" class="btn btn-outline-danger lift mx-2 shadow-sm btn-sm" title="Eliminar">
                            <i class="fa fa-trash-alt"></i>
                        </button>
                        <button @click="imprimir(item.id);" class="btn btn-outline-info lift shadow-sm btn-sm" title="Imprimir">
                            <i class="fa fa-print fa-fw"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <!-- Highlighted Clinical Details: Diagnosis and Days -->
                <div class="row mb-3 pb-3 border-bottom border-light">
                    <div class="col-md-9 border-right">
                        <small class="text-muted d-block font-weight-boldtext-uppercase mb-1">Diagnóstico (CIE-10)</small>
                        <h5 class="font-weight-bold text-dark mb-0" v-if="item.diagnostico">{{item.diagnostico.ID_DIAG}} - {{item.diagnostico.DESC_DIAG}}</h5>
                        <h5 class="font-weight-bold text-muted mb-0" v-else>N/A</h5>
                        <p class="text-black-50 mt-2 mb-0" v-if="item.descripcion"><i class="far fa-comment-alt mr-1"></i> {{item.descripcion}}</p>
                    </div>
                    <div class="col-md-3 text-center">
                        <small class="text-muted d-block font-weight-bold text-uppercase mb-1">Total Días</small>
                        <h2 class="text-primary font-weight-bolder mb-0">{{item.total_dias}}</h2>
                        <small class="text-muted font-weight-bold">Desde {{item.fecha_inicial}} al {{item.fecha_final}}</small>
                    </div>
                </div>

                <!-- Logistics / Classification Meta-data -->
                <div class="row mb-2">
                    <div class="col-md-3">
                        <small class="text-muted d-block">Origen</small>
                        <span class="font-weight-bold"><i class="fas fa-stethoscope text-secondary mr-1"></i> {{item.origen || 'N/A'}}</span>
                    </div>
                    <div class="col-md-3">
                        <small class="text-muted d-block">Clase</small>
                        <span class="font-weight-bold">{{item.clase || 'N/A'}}</span>
                    </div>
                    <div class="col-md-6">
                        <small class="text-muted d-block">Tipología</small>
                        <span class="font-weight-bold">{{item.tipo_incapacidad || 'N/A'}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <small class="text-muted d-block">Grupo de servicios</small>
                        <span class="font-weight-bold"><i class="fas fa-hospital text-secondary mr-1"></i> {{item.grupo_servicios || 'N/A'}}</span>
                    </div>
                    <div class="col-md-6">
                        <small class="text-muted d-block">Modalidad de la prestación</small>
                        <span class="font-weight-bold"><i class="fas fa-laptop-medical text-secondary mr-1"></i> {{item.modalidad_prestacion || 'N/A'}}</span>
                    </div>
                </div>
                <div class="row mt-2" v-if="item.es_retroactiva === 'Si'">
                    <div class="col-md-12">
                        <div class="alert alert-danger py-2 mb-0 mt-2 border-0 rounded">
                            <i class="fas fa-exclamation-triangle mr-1"></i> <strong>Motivo Retroactiva:</strong> {{item.motivo_retroactiva || 'N/A'}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>

import Toast from '../../../../components/common/utilities/toast';
import incapacidadService from '../../../../services/incapacidadService';
import Swal from 'sweetalert2';
export default {
    props: ['idHistoria'],
    data(){
        return {
            incapacidades:{}
        }
    },
    methods: {
        async cargarIncapacidades(id){
            const response = await incapacidadService.showIncapacidadByHc(id);
            this.incapacidades= response.data;
        },
        imprimir(id_incapacidad){
            window.open(incapacidadService.print(id_incapacidad));
        },
        async eliminar(id) {
            const result = await Swal.fire({
                title :  "¿Está seguro de eliminar esta incapacidad?",
                text : "No se podrá revertir los cambios",
                showCancelButton : true,
                showConfirmButton : true,
                confirmButtonText : 'Sí',
                cancelButtonText : 'No',
                icon : "warning",
                showLoaderOnConfirm : true,
                preConfirm: async () => {
                    try{
                        await incapacidadService.delete(id);
                    }catch (e) {
                        console.error(e);
                        Swal.showValidationMessage('ha ocurrido un error al procesar la solicitud');
                    }
                },
            });

            if(result.isConfirmed){
                Toast.fire({
                    icon: 'success',
                    title: 'Datos eliminados con exito'
                });
                this.cargarIncapacidades(this.idHistoria);
            }            
        },
    },
    async created(){
        try {
            await this.cargarIncapacidades(this.idHistoria);
        } catch (error) {
            console.error(error);
            Toast.fire({
                icon: 'error',
                title: 'Ocurrio un error al procesar la solicitud'
            });
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        }
    }
}
</script>